// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import {
  UserInfoResponseDTO,
  UserSearchRequestDTO
} from "../../api/backend-openapi";
import { TablePaginationConfig } from "antd/lib/table/interface";
import { Moment } from "moment";

export interface UserFormProps {
  editMode?: boolean;
}

export interface UsersSearchFormProps {
  pagination: TablePaginationConfig;
  dataHasLoaded: boolean;
  setDataHasLoaded: (dataHasLoaded: boolean) => void;
  onSearchDtoUpdate: (searchDto: UserSearchRequestDTO) => void;
}

export interface UserFormSectionProps extends UserFormProps {
  user?: UserInfoResponseDTO | null;
  showRequired?: boolean;
}

export enum UserWorkflowStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export interface Field {
  name: string[];
  value: string | Moment | string[];
}

export interface UserEditFormProps extends UserFormProps {
  userId: string;
  setEditMode: (editMode: boolean) => void;
  canEdit: boolean;
  canValidate: boolean;
  canDelete: boolean;
}
